import classNames from 'classnames';
import { forwardRef } from 'react';
const subtitleContentCss = "s1bykeya";
export const SubtitleContent = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(subtitleContentCss, props.className)} />;
});
const inputContainerDisabledCss = "i14hf3wf";
const inputContainerActiveCss = "iuvcqtr";
const inputContainerErrorCss = "inscfdj";
const inputContainerCenteredCss = "iuo9f44";
const inputContainerCss = "i1x823y6";
export const InputContainer = forwardRef((props, ref) => {
  const {
    disabled,
    active,
    error,
    centered,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(inputContainerCss, {
    [inputContainerDisabledCss]: disabled,
    [inputContainerActiveCss]: active,
    [inputContainerErrorCss]: error,
    [inputContainerCenteredCss]: centered
  }, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");